import { CSSResultGroup, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './divider.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const dividerOrientations = ['horizontal', 'vertical']
export const dividerVariants = ['solid', 'dashed'] 

@customElement('cse-divider')
export class CSEDivider extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-divider': CSEDivider,
  }
}
